import { ArrowRightIcon } from 'lucide-react';
import { VisitBlock } from '../shared/VisitBlock';
import { salon } from '../../data/content';
import { usePages } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';
import { mediaOr } from '../../core/rules/media';
import { fill } from '../../utils/copy';
import { quietLink } from '../../ui/sections';
import { placeholderImages } from '../../data/placeholderImages';

/**
 * "Kom langs" als slot van de homepage: het gedeelde blok (`VisitBlock`) met de boog die opengaat.
 * De route is een rustige link; de woorden en het beeld komen uit Paginateksten › Home.
 */
export function HomeVisit() {
  const pages = usePages();
  const copy = pages.home.visit;
  const media = mediaOr(copy.media, {
    image: placeholderImages.salonRoom,
    alt: 'Sfeerbeeld: een rustige behandelkamer met linnen in daglicht'
  });
  return <VisitBlock titleId="home-visit" heading={copy.heading} body={copy.body} cta={copy.cta} media={media} motion="arch" links={copy.secondaryCta && <a href={salon.routeUrl} target="_blank" rel="noreferrer" className={`${quietLink} text-ink`} data-id="element-7790" data-mp="x395v1optkt7">
            {fill(copy.secondaryCta)}
            <span className="sr-only" data-id="element-7791" data-mp="121amzh2kza21"> {shopLabels.newTab}</span>
            <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7792" data-mp="1715ffp2087p7" />
          </a>} data-id="element-7789" data-mp="6lvz1f3krs67" />;
}